var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-host-gallery"},[_c('SmallHostGallery',{staticClass:"d-block d-sm-none",attrs:{"images":_vm.imageUrls}}),_c('BigHostGallery',{staticClass:"d-none d-sm-flex",attrs:{"images":_vm.images,"has-show-all-button":_vm.hasShowAllButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }